import React from "react";
import {
  MinusCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

export interface SyncStatusConfig {
  icon: React.ReactNode;
  tooltip: string;
  label: string;
}

export const syncStatusConfig = (
  type?: string
): Record<string, SyncStatusConfig> => ({
  NotApplicable: {
    icon: <MinusCircleOutlined style={{ color: "#8c8c8c" }} />,
    tooltip:
      type === "TimeEntry"
        ? "This time entry is not configured to sync with any external system (e.g., QuickBooks, ADP)."
        : "This employee record is not configured to sync with any external system (e.g., QuickBooks, ADP).",
    label: "Not Applicable",
  },

  Pending: {
    icon: <ClockCircleOutlined style={{ color: "#faad14" }} />,
    tooltip:
      type === "TimeEntry"
        ? "This time entry is queued to be synced to an external system such as QuickBooks or ADP."
        : "This employee is queued to be synced to an external system such as QuickBooks or ADP.",
    label: "Pending Sync",
  },

  InProgress: {
    icon: <SyncOutlined spin style={{ color: "#1677ff" }} />,
    tooltip:
      type === "TimeEntry"
        ? "This time entry is currently syncing to an external system (e.g., QuickBooks, ADP)."
        : "This employee record is currently syncing to an external system (e.g., QuickBooks, ADP).",
    label: "Syncing",
  },

  Synced: {
    icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
    tooltip:
      type === "TimeEntry"
        ? "This time entry has been successfully synced to the external system (e.g., QuickBooks, ADP)."
        : "This employee record has been successfully synced to the external system (e.g., QuickBooks, ADP).",
    label: "Synced",
  },

  Failed: {
    icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
    tooltip:
      type === "TimeEntry"
        ? "Failed to sync this time entry to the external system. Review the error details or retry the sync."
        : "Failed to sync this employee record to the external system. Review the error details or retry the sync.",
    label: "Sync Failed",
  },
});

export const getAlertType = (
  status?: any
): "success" | "info" | "warning" | "error" => {
  switch (status) {
    case "Synced":
      return "success";
    case "InProgress":
      return "warning";
    case "Pending":
    case "NotApplicable":
      return "info";
    case "Failed":
    default:
      return "error";
  }
};
